import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const PageTransition = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!loading) return null;

  return (
    <>
      {/* Top progress bar */}
      <div className="fixed top-0 left-0 right-0 z-50 h-1 bg-gradient-to-r from-brand-cyan via-brand-magenta to-brand-yellow overflow-hidden">
        <div className="h-full w-full bg-white/50 animate-shimmer" />
      </div>

      {/* Mini logo in corner */}
      <div className="fixed top-20 right-4 z-50 animate-bounce">
        <img
          src="/aaa-logo.png"
          alt="Loading"
          className="h-8 w-auto opacity-75"
        />
      </div>
    </>
  );
};
